import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  subscription: Subscription;

  constructor(private storageService: StorageService) {}

  getSitesMarkers() {
    const sites = this.storageService.getSites();
    const markers: any[] = [];

    sites?.forEach((item) => {
      if (item.cer_id === this.storageService.getCer()) {
        const { latitude, longitude } = JSON.parse(item.position_json);

        markers.push({
          options: {
            draggable: false,
            clickable: true,
            animation: google.maps.Animation.DROP,
            icon: 'assets/images/miscellaneus/google_maps_marker.png',
          },
          title: item.id.toString(),
          label: item.description.toString(),
          visible: false,
          position: {
            lat: Number.parseFloat(latitude),
            lng: Number.parseFloat(longitude),
          },
        });
      }
    });
    console.log('Markers ', markers);
    return markers;
    // return MAP_SITES_MOCK;
  }
}
